<template lang="html">
  <div class="domain-help">
    <Guide
      :content="content"
      width="x-small"
      contentHeading="Update DNS Settings"
      buttonText="Settings Updated"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'DomainDnsConfig',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'domain-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'domain-dns-management',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'domain-dns-check',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
        <p>If you've managed to locate your DNS settings, you'll need to add a couple of <strong>A Records</strong> to your domain name:</p>

        <table class="record-table">
          <thead>
            <tr>
              <td>DNS Entry</td>
              <td>Type</td>
              <td>Value/Destination</td>
            </tr>
          </thead>
          <tr>
            <td>
            @
            </td>
            <td>
            A
            </td>
            <td>
              206.189.31.34
            </td>
          </td>
          <tr>
            <td>
              www
            </td>
            <td>
              A
            </td>
            <td>
              206.189.31.34
            </td>
          </tr>
        </table>

        <hr>
        <p>Alternatively, send this to your domain support.</p>

        <div class="helper-text">
          <p>Hello. I purchased a domain name from you and I'd like to update my DNS settings. Please can you update the A Records to the following?</p>
            <table class="record-table table-message">
              <tr>
                <td>
                @
                </td>
                <td>
                  206.189.31.34
                </td>
              </td>
              <tr>
                <td>
                  www
                </td>
                <td>
                  206.189.31.34
                </td>
              </tr>
            </table>
          </div>
      `
    }
  }
}
</script>

<style lang="sass">
  .record-table
    border-radius: 5px
    margin: auto
    padding: 5px
    margin-right: auto
    margin-bottom: 20px
    font-weight: bold
    opacity: 0.6

    &.table-message
      background: rgba(0, 0, 0, 0.05)

    thead
      td
        border-bottom: 1px solid rgba(0, 0, 0, 0.2)

    td
      padding: 6px 10px
</style>
